import WelcomePage from './views/WelcomePage.vue';
import PackageCanvas from './views/PackageCanvas.vue';
export const packageCanvasRoutes = [
  {
    path: '/packageCanvas',
    name: 'PackageCanvas',
    children: [
      {
        path: ':workspaceId',
        name: 'PackageCanvas.EditPackageCanvasPage',
        component: PackageCanvas
      }
    ]
  }
];
